import { custom, success } from "./utilities";
import { blogConstants, globalConstants } from "../../constants";
import { blogService } from "../../services/blog.services";
import { ToastifyService } from "../../services/toastify.services";

const gridData = {
  column: "",
  type: "",
  search: null,
  filters: [],
};

export const getAllBlog = (gridState) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    blogService
      .getAll(gridState)
      .then((response) => {
        dispatch(success(response.data, blogConstants.GET_BLOGS));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const getBlogById = (id) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    blogService
      .getById(id)
      .then((response) => {
        dispatch(success(response.data, blogConstants.GET_BLOG_BY_ID));
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const deleteBlogById = (id, projectId = 0) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    blogService
      .deleteById(id)
      .then((response) => {
        dispatch(getAllBlog(gridData));
        ToastifyService.showSuccess("Status Updated Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const createBlog = (data, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    blogService
      .create(data)
      .then((response) => {
        dispatch(getAllBlog(gridData));
        onHide();
        ToastifyService.showSuccess("Done Successfully");
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const updateBlog = (data, id, onHide) => {
  return (dispatch) => {
    dispatch(success(true, globalConstants.SPINNER_ACTIVATE));
    blogService
      .update(data, id)
      .then((response) => {
        dispatch(getAllBlog(gridData));
        onHide();
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(success(false, globalConstants.SPINNER_ACTIVATE));
      });
  };
};

export const blogActions = {
  getAllBlog,
  getBlogById,
  deleteBlogById,
  createBlog,
  updateBlog,
};
